import PropTypes from 'prop-types';
import { useState } from 'react';
import { InspectionListActionsMap } from 'constants/inspections';

export const useInspectionListWarningDialog = ({
  handleInspectionArchive,
  handleInspectionDelete,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [actionSelected, setActionSelected] = useState();
  const [deleteMediaCheckbox, setDeleteMediaCheckbox] = useState(false);
  const [inspectionSelected, setInspectionSelected] = useState();

  const handleSelectRow = (action, inspectionId) => {
    setOpenDialog(true);
    setInspectionSelected(inspectionId);
    setActionSelected(action);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setActionSelected();
    setDeleteMediaCheckbox();
    setInspectionSelected();
  };

  const handleDialogAction = () => {
    switch (actionSelected) {
      case InspectionListActionsMap.ARCHIVE:
        handleInspectionArchive(inspectionSelected);
        break;
      case InspectionListActionsMap.DELETE:
        handleInspectionDelete(inspectionSelected, deleteMediaCheckbox);
        break;
    }
    handleCloseDialog();
  };

  return {
    openDialog,
    handleCloseDialog,
    handleDialogAction,
    setDeleteMediaCheckbox,
    actionSelected,
    handleSelectRow,
  };
};

useInspectionListWarningDialog.propTypes = {
  handleInspectionArchive: PropTypes.func,
  handleInspectionDelete: PropTypes.func,
};
